require('dotenv').config();
const URL_SERVIDOR = process.env.VUE_APP_URL_SERVIDOR;
const URL_SERVIDOR_IS  = process.env.VUE_APP_URL_SERVIDOR_IS;
const URL_SERVIDOR_WS = process.env.VUE_APP_URL_SERVIDOR_WS;

export default {
  URL_SERVIDOR: URL_SERVIDOR, 
  URL_SERVIDOR_IS: URL_SERVIDOR_IS,
  URL_SERVIDOR_WS: URL_SERVIDOR_WS,
}